import { AuthenticationService } from "../services/authentication.service";
var MainComponent = (function () {
    function MainComponent(authService) {
        this.authService = authService;
    }
    MainComponent.prototype.ngOnInit = function () {
        this.authService.reloadUserInfo();
        //start intercom live chat
        // window["Intercom"]("boot", {
        //   app_id: "isx1jbmb"
        // });
    };
    return MainComponent;
}());
export { MainComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/main/main.component.ts.pre-build-optimizer.js